import { Skull, Ghost, Flame, Sparkles, Moon } from "lucide-react";

const phrases = [
  { text: "Don't get spooked out of your bags", Icon: Skull },
  { text: "No tricks, only treats", Icon: Ghost },
  { text: "Traded exclusively on FOMO app", Icon: Flame },
  { text: "Liquidity haunted forever", Icon: Sparkles },
  { text: "The green candle graveyard", Icon: Moon },
];

export default function Marquee() {
  return (
    <section
      data-testid="editorial-marquee"
      aria-label="FOMOWEEN slogans"
      className="overflow-hidden border-y border-orange-500/20 bg-[#0B0814] py-6"
    >
      <div className="marquee-track">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex items-center" aria-hidden={copy === 1}>
            {phrases.map(({ text, Icon }) => (
              <span
                key={`${copy}-${text}`}
                className="mx-10 flex items-center gap-10 whitespace-nowrap font-syne text-lg font-bold uppercase tracking-wide text-zinc-500 sm:text-2xl"
              >
                {text}
                <Icon className="shrink-0 text-pumpkin" size={22} />
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
